import instagram from "../Components/Assets/instagram_icon.png";
import youtube from "../Components/Assets/youtube_icon.png";
import facebook from "../Components/Assets/facebook_icon.png";
import "./CSS/Confirmation.css";
import { useEffect, useState } from "react";

const Confirmation = () => {
  const [digitalItems, setDigitalItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("processing"); // processing | done | error
  const [customerEmail, setCustomerEmail] = useState("");

  useEffect(() => {
    const processOrder = async () => {
      try {
        // ✅ Read from localStorage — survives Square's external redirect
        const purchasedItemsStr = localStorage.getItem("purchasedItems");
        console.log("Raw localStorage purchasedItems:", purchasedItemsStr);

        if (!purchasedItemsStr) {
          console.warn("No purchased items found in localStorage.");
          setOrderStatus("done");
          return;
        }

        const purchasedItems = JSON.parse(purchasedItemsStr);
        console.log("Parsed purchased items:", purchasedItems);

        // Log what we have for each item
        purchasedItems.forEach((item, idx) => {
          console.log(
            `Item ${idx}: ${item.name} | fileType="${item.fileType}" | pdfUrl="${item.pdfUrl}"`,
          );
        });

        // Get customer email if logged in
        const email = localStorage.getItem("customerEmail") || "";
        setCustomerEmail(email);

        // Get Square order ID from URL if present
        const params = new URLSearchParams(window.location.search);
        const squareOrderId =
          params.get("orderId") ||
          params.get("transactionId") ||
          `order-${Date.now()}`;

        // ✅ Call /confirm-order — handles inventory, tokens, and email in one shot
        const confirmRes = await fetch(
          "https://backend.mariemadeit.com/confirm-order",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              cart: purchasedItems,
              customerEmail: email,
              squareOrderId,
            }),
          },
        );

        const confirmData = await confirmRes.json();
        console.log("Confirm order response:", confirmData);

        if (!confirmData.success) {
          console.error("Confirm order failed:", confirmData.error);
          setOrderStatus("error");
          return;
        }

        // Show digital items on page for immediate download (backup to email)
        const digital = purchasedItems.filter(
          (item) =>
            (item.fileType === "digital" || item.fileType === "both") &&
            item.pdfUrl,
        );
        setDigitalItems(digital);
        setOrderStatus("done");

        // ✅ Clear localStorage after successful order processing
        localStorage.removeItem("purchasedItems");
      } catch (error) {
        console.error("Error processing order:", error.message);
        setOrderStatus("error");
      }
    };

    processOrder();
  }, []);

  // Immediate download button (backup — email is the primary delivery)
  const handleDownload = (pdfUrl, itemName) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `${itemName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="confcontainer">
      <div className="confirmation-page">
        <h1>Thank You for Your Purchase!</h1>

        {orderStatus === "processing" && (
          <p>Processing your order, please wait...</p>
        )}

        {orderStatus === "error" && (
          <p style={{ color: "red" }}>
            There was an issue processing your order. Please contact us if you
            don't receive your items.
          </p>
        )}

        {orderStatus === "done" && (
          <>
            <p>Your receipt has been sent to your email for your records.</p>

            {/* Digital Downloads Section */}
            {digitalItems.length > 0 ? (
              <div className="digital-downloads">
                <h2>Your Digital Downloads</h2>
                <p>
                  A download link has been sent to{" "}
                  <strong>{customerEmail || "your email"}</strong>. You can also
                  download directly here:
                </p>
                <div className="downloads-list">
                  {digitalItems.map((item, index) => (
                    <div key={index} className="download-item">
                      <p className="download-name">{item.name}</p>
                      <button
                        className="download-button"
                        onClick={() => handleDownload(item.pdfUrl, item.name)}
                      >
                        Download PDF
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="no-digital-items">
                <p>No digital items in this order.</p>
              </div>
            )}
          </>
        )}

        <h2>
          Stay connected with us by following MarieMadeIt on social media for
          updates, new products, and Pattern tester calls.
        </h2>
        <a
          className="social"
          href="https://www.instagram.com/mariemadeit__/?hl=en"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagram} alt="instagram-logo" />
          Instagram
        </a>
        <a
          className="social"
          href="https://www.youtube.com/@MarieMadeIt96"
          target="_blank"
          rel="noreferrer"
        >
          <img src={youtube} alt="youtube-logo" />
          Youtube
        </a>
        <a
          className="social"
          href="https://www.facebook.com/profile.php?id=100077528543304"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebook} alt="facebook-logo" />
          Facebook
        </a>
        <p>Thank you once again for choosing MarieMadeIt!</p>
        <a className="returnbtn" href="/">
          Return Home
        </a>
      </div>
    </div>
  );
};

export default Confirmation;
